
import { Options, Vue } from "vue-class-component";
import { namespace } from 'vuex-class';
import CardRh from "@/components/cards/ManzaCard.vue";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import MatriculaService from "@/service/v1/sigap/MatriculaService";
import { Prop } from 'vue-property-decorator';

const authStore = namespace('auth');

@Options({
    name: "DisciplinaVF",
    components: { CardRh, KDataTable },
})
export default class DisciplinaVF extends Vue {
    @authStore.Getter
    public perfis!: any;

    @authStore.Getter
    public token!: any;

    @Prop() readonly disciplina!: any;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;
    public disciplinaId: any = null;
    public turmaId: any = null;
    public pelotao = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.pelotao = '';
        this.refreshTable();
    }

    public exportarPdf() {
        const url = this.service.getVerificacaoFinalPdfUrl({
            disciplinaId: this.disciplinaId,
            turmaId: this.turmaId,
            pelotao: this.pelotao,
        }, this.token);
        window.open(url, '_blank');
    }

    created() {
        this.disciplinaId = this.$route.params.id;
        this.turmaId = this.disciplina.turmaId;
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.service = new MatriculaService();
        this.config.ajax = {
            url: this.service.getApiUrl() + '/VerificacaoFinal',
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    disciplinaId: this.disciplinaId,
                    turmaId: this.turmaId,
                    pelotao: this.pelotao,
                    search: d.search.value,
                };
                return dados;
            }
        };
        this.config.columns = [
            { data: 'matricula.usuario.nome', name: 'aluno', orderable: false },
            { data: 'matricula.pelotao', name: 'pelotao', class: 'text-center' , orderable: false},
            { data: 'notaVC', name: 'notavc' , orderable: false},
            { data: 'notaVF', name: 'notavf', orderable: false },
            { data: 'notaVR', name: 'notavr', orderable: false },
        ];
    }

    pushColunaAcoes() {
        this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
    }
}
